const STEPS = {
	PAY_NOW: 'PAY_NOW',
	PAY_NOW_LOCKED: 'PAY_NOW_LOCKED',
	CREDIT_CARD: 'CREDIT_CARD',
	CREDIT_CARD_RESULT: 'CREDIT_CARD_RESULT',
	EDIT_COMMISSION: 'EDIT_COMMISSION',
	PAYMENT_METHOD: 'PAYMENT_METHOD',
	SEND_PAY_LATER_LINK: 'SEND_PAY_LATER_LINK',
	BANK_TRANSFER: 'BANK_TRANSFER',
	BANK_TRANSFER_RESULT: 'BANK_TRANSFER_RESULT',
};

const PAYMENT_TYPE = {
	CREDIT_CARD: 'CREDIT_CARD',
	SEND_PAY_LATER_LINK: 'SEND_PAY_LATER_LINK',
	GENERATED_PAY_LATER_LINK: 'GENERATED_PAY_LATER_LINK',
	BANK_TRANSFER: 'BANK_TRANSFER',
};

const FIELD_PADDING = {
	'& .MuiOutlinedInput-root': {
		pr: '6px !important',
	}
}

module.exports = {
	STEPS,
	PAYMENT_TYPE,
	FIELD_PADDING
};
